import type { KioskFlowValidationError } from './kiosk-flow-types';

// The backoffice rejected the flow — validationErrors has the per-step detail
export class KioskFlowValidationFailure extends Error {
  constructor(
    message: string,
    readonly validationErrors: KioskFlowValidationError[]
  ) {
    super(message);
    this.name = 'KioskFlowValidationFailure';
  }
}

// The draft changed between prepare and record — the version can't be recorded, publish again
export class KioskFlowConflictError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'KioskFlowConflictError';
  }
}

export type PublishStage = 'prepare' | 'push' | 'record';

// A publish failed at one stage. After a push the kiosks already run the new flow, so a
// 'record' failure carries the pushed JSON to retry recording without pushing again.
export class PublishError extends Error {
  constructor(
    readonly stage: PublishStage,
    readonly reason: Error,
    readonly pushedJson: string | null = null
  ) {
    super(reason.message);
    this.name = 'PublishError';
  }
}
